<template>
  <v-container>
    <div class="title-icon">
      <h1>{{ $t("company.exemption-title.exemptions") }}</h1>
      <v-btn
        icon
        :href="links.application.instructorDispensations"
        target="_blank"
      >
        <v-icon>$sl-question</v-icon>
      </v-btn>
    </div>

    <p>
      {{ $t("company.exemptions-p-explanation") }}
    </p>

    <p>
      {{ $t("company.exemptions-p") }}
    </p>

    <v-text-field
      class="search-field mb-6 mt-5"
      prepend-icon="$sl-search"
      single-line
      hide-details
      :label="$t('application.search-label')"
      @input="init"
      v-model="search"
    ></v-text-field>

    <template v-if="hasDepartments($route.params.id) == true">
      <MessageBox type="info" class="mb-8" v-if="!isAdministrator">
        <p>
          {{ $t("company.exemption-messagebox") }}
          {{ getCurrentUserDepartments($route.params.id, isAdministrator, false) }}
        </p>
      </MessageBox>
      <v-tabs
        v-model="tab"
        :fixed-tabs="$vuetify.breakpoint.xsOnly"
        :centered="$vuetify.breakpoint.xsOnly"
      >
        <v-tab key="1">{{ $t("labels.all") }}</v-tab>
        <v-tab key="2">{{ $t("company.sections") }}</v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item key="1">
          <CompanyExemptionsItems
            :searchedexemptions="searchedexemptions"
          ></CompanyExemptionsItems>
        </v-tab-item>
        <v-tab-item key="2">
          <CompanyExemptionsDepartments
            :searched="searchedDep"
          ></CompanyExemptionsDepartments>
        </v-tab-item>
      </v-tabs-items>
    </template>
    <CompanyExemptionsItems
      v-else
      :searchedexemptions="searchedexemptions"
    ></CompanyExemptionsItems>
    <v-btn
      fixed
      fab
      bottom
      right
      class="elevation"
      color="primary"
      :disabled="isImitatingUser()"
      @click="
        $nextTick(() => {
          $router.push({
            name: 'CompanyExemptionNew',
            params: { company_id: $route.params.id },
          });
        })
      "
    >
      <v-icon>$sl-add</v-icon>
    </v-btn>
  </v-container>
</template>

<script>
import API from "@/services/api.js";
import ActionButton from "@/components/Common/ActionButton";
import { CompanyRoles } from "@/components/mixins";
import { mapActions, mapGetters } from "vuex";
import CompanyExemptionsItems from "@/components/Company/CompanyExemptionsItems";
import MessageBox from "@/components/Common/MessageBox";
import CompanyExemptionsDepartments from "@/components/Company/CompanyExemptionsDepartments";
import filter from "lodash/filter";
import find from "lodash/find";
import uniq from "lodash/uniq";

// @group Company
// CompanyExemption component
export default {
  name: "CompanyExemptions",

  mixins: [CompanyRoles],

  components: {
    ActionButton,
    MessageBox,
    CompanyExemptionsItems,
    CompanyExemptionsDepartments,
  },

  data: () => ({
    links: require('../../lib/external-links.json'),
    search: "",
    tab: null,
    exemptions: [],
  }),

  created() {
    this.init();
  },

  computed: {
    ...mapGetters("currentuser", ["currentUser", "isInstructor", "isAdministrator", "isImitatingUser"]),
    /**
     * Used get all exemptions or search exemptions if search is required from user
     * @arg called with no is a string comming from search bar
     */
    searchedexemptions() {
      let result = [];
      if (this.search === "") {
        result = this.exemptions;
      } else {
        let normalizedSearch = this.search.toLowerCase();
        result = this.exemptions.filter((x) =>
          x.person.firstName.toLowerCase().includes(normalizedSearch)
        );
      }

      return result;
    },
    searchedDep() {
      let result = [];
      if (this.search === "") {
        result = this.exemptions;
      } else {
        let normalizedSearch = this.search.toLowerCase();

        result = this.exemptions.filter(
          (x) =>
            (x.person.firstName &&
              x.book.firstName.toLowerCase().includes(normalizedSearch)) ||
            (x.person.lastName &&
              x.person.lastName.toLowerCase().includes(normalizedSearch))
        );
      }
      return result;
    },
  },

  methods: {
    /**
     * @vuese
     * Used to call method  getApprenticeById or  getEmployeeById based on route name
     * @arg called with no argument
     */
    init() {
      this.getExemptions();
    },
    /**
     * @vuese
     * Used to fetch exemptions
     * @arg The argument is an integer value representing company id
     */
    getExemptions() {
      if (!(this.$route && this.$route.params && this.$route.params.id)) return;
      API.listExemptions(this.$route.params.id).then((response) => {
        let filterByApprovedStatus = filter(response.data.rows, ["status", "approved"]);
        //console.log(filterByApprovedStatus, "resp::", response.data.rows);
        let b = [];
        filterByApprovedStatus.forEach((item) => {
          let f = b.find((o) => o.person && o.person.id === item.person.id);
          const merged = { ...item.profession, ...item.issuedBy };
          merged.approvedOn = item.approvedOn;
          if (f && f.profession) {
            f.professions.push(merged);
          } else {
            item.professions = [merged];
            b.push(item);
          }
        });

        // Filtered the exemption list if the company has departments with the department roles.
        if (this.hasDepartments(this.$route.params.id)) {
          let emp = this.currentUser.employments.find(
            (x) => x.companyId == this.$route.params.id
          );
          let exemp = [];

          b.forEach((r) => {
            r.person.employments.forEach((employment) => {
              if (employment.companyId == this.$route.params.id) {
                if (
                  employment.departmentEmployments &&
                  employment.departmentEmployments.length > 0
                ) {
                  employment.departmentEmployments.forEach((e) => {
                    if (this.isAdministrator == true) {
                      exemp.push(r);
                    } else if (this.hasDepartmentId(emp, e.department.id) == true) {
                      exemp.push(r);
                    }
                  });
                }
              }
            });
          });
          this.exemptions = this.employees = uniq(exemp, "id");
        } else {
          this.exemptions = b;
        }
      });
    },
  },
};
</script>
<style scoped></style>
